import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Actions from '@app/action';
import Illustration from '@component/illustration';
import I18n from '@module/i18n';
import Recaptcha from '@module/recaptcha';
import Metric from '@module/metric';

export class ReCaptcha extends React.Component {
  constructor(props) {
    super(props);
    this.onVerifyClick = this.onVerifyClick.bind(this);
  }

  componentDidMount() {
    Recaptcha.load();
    Recaptcha.onToken = this.props.validateRecaptcha;
    Metric.send('human_verification_required');
  }

  componentDidUpdate() {
    const { notification } = this.props;
    if (notification.transfer.text === 'RecaptchaFailed') {
      Metric.send('human_verification_failed');
      Recaptcha.reset();
    }
  }

  displayErrorNotification() {
    this.props.pushTransfer({ text: 'RecaptchaFailed' });
  }

  onVerifyClick() {
    try {
      Recaptcha.execute();
    } catch (e) {
      this.displayErrorNotification();
    }
  }

  renderContent() {
    const title = I18n.t('transfer.recaptcha.title');
    const text = I18n.t('transfer.recaptcha.text');
    return [
      <div key="transfer_complete_illustration" className="transfer__contents">
        <Illustration type="transfer-password" className="uploader__image" />
        <h2>{title}</h2>
        <p className="complete__text">{text}</p>
      </div>,
    ];
  }

  render() {
    const contents = this.renderContent();
    const buttonText = I18n.t('transfer.recaptcha.button');

    const button = (
      <button className="transfer__button" onClick={this.onVerifyClick}>
        {buttonText}
      </button>
    );

    return (
      <div className="transfer__window uploader uploader--complete">
        {contents}
        <div className="transfer__footer">{button}</div>
      </div>
    );
  }
}

ReCaptcha.propTypes = {
  notification: PropTypes.object,
  validateRecaptcha: PropTypes.func.isRequired,
  pushTransfer: PropTypes.func.isRequired,
};

ReCaptcha.defaultProps = {
  notification: {},
};

const mapStateToProps = ({ notification }) => ({ notification });

const mapDispatchToProps = {
  validateRecaptcha: Actions.Transfer.validateRecaptcha.bind(Actions.Transfer),
  pushTransfer: Actions.Notification.pushTransfer,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReCaptcha);
